import {IUserStatistic} from '@/stores/ItemsStore/ItemsStore.types';

import {BlackListStringValidationRule, StatisticValidationRule} from '@/resources';
import {FrontendError} from '@/services/ErrorService/FrontendError';
import {StatisticItemValidationType} from '@/types';
import {ValidationUtils} from '@/utils/ValidationUtils';

export const validateBlackListString = (
  statistic: IUserStatistic,
  rule: StatisticValidationRule,
  logError: (error: FrontendError) => void,
  shouldLogError = true,
): string | null => {
  if (
    !ValidationUtils.isValidationRule<BlackListStringValidationRule>(rule, StatisticItemValidationType.BlackListString)
  ) {
    return null;
  }

  const statisticValue = statistic.value;
  const ruleValue = rule.value;

  if (ValidationUtils.isInvalidStringValue(statisticValue)) {
    // логируем некорректное строковое значение
    const error = FrontendError.createInvalidStringValueError(statistic.metricDesc, statisticValue);
    logError(error);

    return null;
  } else if (ruleValue.size && ruleValue.has(statisticValue.toLowerCase())) {
    // логируем значение из черного списка
    const error = FrontendError.createBlackListStringValueError(statistic.metricDesc, statisticValue);

    if (shouldLogError) {
      logError(error);
    }

    return null;
  }

  return statisticValue;
};
